import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Grid,
  Container,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  TextField,
  Select,
  MenuItem,
  Card,
  Button,
  Dialog,
  DialogContent,
  FormGroup,
} from "@mui/material";
import {
  parseCurrency,
  parseDate,
  parseTime,
} from "../../utils/tableFunctions";
import { getMismatchDetails } from "../../services/reconciliations";
import { postMismatch } from "../../services/reconciliations";
import ReconDetailsHeader from "./ReconDetailsHeader";
import { Box } from "@mui/system";
import { useUserContext } from "../../context/userContext";
import CircularLoader from "../../components/circularLoader";

// A list of reasons for user to select when user wants to reconcile
const reasonList = [
  {
    reason: "Rounding Differences",
  },
  {
    reason: "Testing Fees",
  },
  { reason: "Other" },
];

const MismatchedDetails = () => {
  // const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [other, setOther] = useState("");
  const [details, setDetails] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [selectAmount, setSelectAmount] = useState("");
  const [selectCurr, setSelectCurr] = useState("");
  const [refs, setRefs] = useState([]);
  const userRole = useUserContext();

  const [selected, setSelected] = useState({ currency: null, amount: null });

  const handleCurrButton = (curr) => {
    setSelectCurr(curr);
  };

  const handleAmountButton = (amount) => {
    setSelectAmount(amount);
  };

  const { id } = useParams();
  useEffect(() => {
    if (!loaded) {
      getMismatchDetails(id, setDetails, setRefs, setLoaded);
    }
  }, [id, loaded]);

  const handleDialogOpen = () => {
    // Need to check if both amount and currency are selected
    if (
      (selectAmount && selectCurr) ||
      (!details.payx_request_currency &&
        !details.acquirer_request_currency &&
        selectAmount)
    ) {
      // setIsOpen(!isOpen);
      setOpen(true);
    } else {
      alert("Please select the correct values!");
    }
  };
  // const handleDialogClose = () => {
  //   setIsOpen(false);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleDropdownChange = (event) => {
    setReason(event.target.value);
  };

  const handleSubmit = () => {
    setOpen(false);
    // Handle Patch request here
    postMismatch({
      pk: id,
      currency: selectCurr,
      amount: selectAmount,
      comment: `${reason === "Other" ? other : reason}`,
    });
  };

  const openDialog = () => {
    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogContent sx={{ width: "30rem" }}>
          <FormGroup>
            <Typography variant="body1" sx={{ mt: "25px" }}>
              Choose your reason
            </Typography>
            <Select
              value={reason}
              onChange={handleDropdownChange}
              style={{ minWidth: "100%" }}
              displayEmpty
            >
              {reasonList.map((reason) => (
                <MenuItem key={reason.reason} value={reason.reason}>
                  {reason.reason}
                </MenuItem>
              ))}
            </Select>
            {reason === "Other" && (
              <TextField
                value={other}
                onChange={(e) => setOther(e.target.value)}
                label="Other Reason"
                sx={{ my: 2 }}
              />
            )}
          </FormGroup>
          <Button
            sx={{ alignSelf: "center", mt: 2 }}
            variant="outlined"
            size="large"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </DialogContent>
      </Dialog>
    );
  };

  const renderDialog = () => {
    return (
      <>
        <Dialog
          isOpen={open}
          onClose={() => setOpen(false)}
          style={{
            alignItems: "center",
            width: "70%",
            backgroundColor: "#fff",
          }}
        >
          <FormGroup style={{ width: "70%" }}>
            <Typography variant="body1" sx={{ mt: "25px" }}>
              Choose your reason
            </Typography>
            <Select
              value={reason}
              label="Reason"
              onChange={handleDropdownChange}
              style={{ minWidth: "100%" }}
            >
              {reasonList.map((reason) => (
                <MenuItem key={reason.reason} value={reason.reason}>
                  {reason.reason}
                </MenuItem>
              ))}

              <MenuItem value={other}>Other</MenuItem>
            </Select>
            {!other ? (
              <>
                <Typography variant="body1" sx={{ mt: "15px" }} hidden>
                  Other reason
                </Typography>

                <TextField
                  id="standard-basic"
                  disabled
                  hidden
                  variant="standard"
                  sx={{
                    mb: "10px",
                    minWidth: "100%",
                  }}
                />
              </>
            ) : (
              <>
                <Typography variant="body1" sx={{ mt: "15px" }}>
                  Other reason
                </Typography>
                <TextField
                  id="standard-basic"
                  variant="standard"
                  onChange={(e) => setOther(e.target.value)}
                  sx={{
                    mb: "10px",
                    minWidth: "100%",
                  }}
                  value={other}
                />
              </>
            )}
            {/* <Typography variant="body1" sx={{ mt: "15px" }}>
              Comments
            </Typography>
            <TextField
              id="standard-basic"
              variant="standard"
              onChange={handleCommentChange}
              sx={{ mb: "10px", minWidth: "90%" }}
            /> */}
          </FormGroup>
          <Button
            text="Submit"
            large="true"
            outlined="true"
            onClick={handleSubmit}
            sx={{ mt: 2 }}
          />
        </Dialog>
      </>
    );
  };

  const renderMismatchedCard = (detail) => {
    return (
      <Grid
        container
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 2, sm: 2, md: 2 }}
        sx={{ mt: 5 }}
      >
        <Grid item xs={6} md={6}>
          <Card sx={{ p: 3 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6} md={5}>
                <Typography variant="subtitle1">Transaction ID</Typography>
              </Grid>
              <Grid
                item
                xs={6}
                md={7}
                sx={{
                  overflowWrap: "normal",
                  wordBreak: "break-word",
                }}
              >
                {detail.transaction?.id ?? detail?.acquirer_reference_no}
              </Grid>

              <Grid item xs={6} md={5}>
                <Typography variant="subtitle1">Transaction Time</Typography>
              </Grid>
              <Grid item xs={6} md={7}>
                {`${parseDate(detail.transaction_datetime)} ${parseTime(
                  detail.transaction_datetime
                )}`}
              </Grid>

              <Grid item xs={6} md={5}>
                <Typography variant="subtitle1">
                  Acquirer Request Amount
                </Typography>
              </Grid>
              <Grid item xs={6} md={7}>
                {detail.acquirer_request_currency &&
                  `${detail.acquirer_request_currency} ${parseCurrency(
                    detail.acquirer_request_amount
                  )}`}
              </Grid>
              <Grid item xs={6} md={5}>
                <Typography variant="subtitle1">Card Number</Typography>
              </Grid>
              <Grid item xs={6} md={7}>
                {detail.payer_details
                  ? detail.payer_details.payer_card_masked
                  : ""}
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={6} md={6}>
          <Card sx={{ p: 3 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6} md={5}>
                <Typography variant="subtitle1">
                  Reference Number
                </Typography>
              </Grid>
              <Grid
                item
                xs={4}
                md={7}
                sx={{
                  overflowWrap: "normal",
                  wordBreak: "break-word",
                }}
              >
                {detail.reference_number || ""}
              </Grid>
              <Grid item xs={6} md={5}>
                <Typography variant="subtitle1">
                  Transaction Type
                </Typography>
              </Grid>
              <Grid item xs={4} md={7}>
                {detail.transaction_type?.transaction_type}
              </Grid>
              <Grid item xs={6} md={5}>
                <Typography variant="subtitle1">
                  Request Amount
                </Typography>
              </Grid>
              <Grid item xs={4} md={7}>
                {detail.transaction_currency &&
                  `${detail.transaction_currency} ${parseCurrency(
                    detail.transaction_amount
                  )}`}
              </Grid>

              <Grid item xs={6} md={5}>
                <Typography variant="subtitle1">Status</Typography>
              </Grid>
              <Grid item xs={4} md={7}>
                {detail.oxygen7_state ? detail.oxygen7_state : ""}
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Container>
        {loaded ? (
          <>
            <ReconDetailsHeader
              loaded={loaded}
              title="Mismatched Reconciliations Details"
              details={details}
            />
            {renderMismatchedCard(details)}

            {/* For input/selection */}
            <Card sx={{ p: 3, mt: 5 }}>
              <Typography
                variant="h4"
                sx={{
                  backgroundColor: "primary.main",
                  marginTop: "1rem",
                  color: "#fff",
                  padding: "5px",
                  textAlign: "center",
                }}
              >
                Select Correct Values
              </Typography>

              <Table sx={{ tableLayout: "fixed" }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center"></TableCell>
                    <TableCell align="center">Internal</TableCell>
                    <TableCell align="center">External</TableCell>
                    <TableCell align="center">Selected</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loaded ? (
                    <>
                      <TableRow>
                        <TableCell align="center">
                          <strong>Currency</strong>
                        </TableCell>

                        <TableCell align="center">
                          <Button
                            variant={
                              selected.currency === "internal"
                                ? "outlined"
                                : "text"
                            }
                            size="large"
                            onClick={() => {
                              setSelected((prev) => ({
                                ...prev,
                                currency: "internal",
                              }));
                              handleCurrButton(
                                details.transaction_currency,
                                details.transaction_amount
                              );
                            }}
                            disabled={details.transaction_currency === null}
                          >
                            {details.transaction_currency || ""}
                          </Button>
                        </TableCell>

                        <TableCell align="center">
                          <Button
                            variant={
                              selected.currency === "external"
                                ? "outlined"
                                : "text"
                            }
                            size="large"
                            onClick={() => {
                              setSelected((prev) => ({
                                ...prev,
                                currency: "external",
                              }));
                              handleCurrButton(
                                details.acquirer_request_currency,
                                details.acquirer_request_amount
                              );
                            }}
                            disabled={
                              details.acquirer_request_currency === null
                            }
                          >
                            {details.acquirer_request_currency || ""}
                          </Button>
                        </TableCell>

                        <TableCell align="center">
                          <Typography variant="subtitle1" color="info">
                            {selectCurr}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="center">
                          <strong>Amount</strong>
                        </TableCell>

                        <TableCell align="center">
                          <Button
                            variant={
                              selected.amount === "internal"
                                ? "outlined"
                                : "text"
                            }
                            size="large"
                            onClick={() => {
                              setSelected((prev) => ({
                                ...prev,
                                amount: "internal",
                              }));
                              handleAmountButton(details.transaction_amount);
                            }}
                          >
                            {parseCurrency(details.transaction_amount)}
                          </Button>
                        </TableCell>

                        <TableCell align="center">
                          <Button
                            variant={
                              selected.amount === "external"
                                ? "outlined"
                                : "text"
                            }
                            size="large"
                            onClick={() => {
                              setSelected((prev) => ({
                                ...prev,
                                amount: "external",
                              }));
                              handleAmountButton(
                                details.acquirer_request_amount
                              );
                            }}
                          >
                            {parseCurrency(details.acquirer_request_amount)}
                          </Button>
                        </TableCell>

                        <TableCell align="center">
                          <Typography variant="subtitle1" color="info">
                            {parseCurrency(selectAmount)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </>
                  ) : null}
                </TableBody>
              </Table>

              <Container
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <Button
                  variant="contained"
                  sx={{ mt: 3 }}
                  size="large"
                  onClick={handleDialogOpen}
                  intent="success"
                >
                  Reconcile
                </Button> */}
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleDialogOpen}
                  sx={{ mt: 3 }}
                  disabled={
                    !userRole.reconsettlement.includes("Reconciliation")
                  }
                >
                  Reconcile
                </Button>
              </Container>
            </Card>
            {/* {renderDialog()} */}
            {openDialog()}

            {loaded &&
              refs.length > 1 &&
              refs.slice(1).map((trans) => {
                return (
                  <Box sx={{ height: 30 }}>{renderMismatchedCard(trans)}</Box>
                );
              })}
          </>
        ) : (
          <CircularLoader />
        )}
      </Container>
    </>
  );
};

export default MismatchedDetails;
